import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { AngularSvgIconModule } from 'angular-svg-icon';

let UiCCardsManagerComponent = class UiCCardsManagerComponent {
    constructor() {
        this.rqCard = new EventEmitter();
        this.ulkCard = new EventEmitter();
        this.cgPassword = new EventEmitter();
        this.blCard = new EventEmitter();
        this.csCard = new EventEmitter();
        this.actCard = new EventEmitter();
    }
    requestCard() {
        this.rqCard.emit();
    }
    unlockedCard(card) {
        this.ulkCard.emit(card);
    }
    changePassword(card) {
        this.cgPassword.emit(card);
    }
    blockCard(card) {
        this.blCard.emit(card);
    }
    closeCard(card) {
        this.csCard.emit(card);
    }
    activeCard(card) {
        this.actCard.emit(card);
    }
    selectCard(cards) {
        this.swButtons = false;
        this.cardSelected = cards;
    }
    showButtons(card) {
        if (card.status === '0') {
            if (this.swButtons) {
                this.swButtons = false;
            }
            else {
                this.swButtons = true;
            }
        }
        else if (card.status === '1') {
            this.activeCard(card);
        }
    }
    blockedCard(status) {
        if (status === '2') {
            return 'blocked';
        }
        else {
            return '';
        }
    }
    statusCard(status) {
        switch (status) {
            case '0': return 'CARDS.CARD_MANAGER.STATUS_CARD.ACTIVE';
            case '1': return 'CARDS.CARD_MANAGER.STATUS_CARD.INACTIVE';
            case '2': return 'CARDS.CARD_MANAGER.STATUS_CARD.BLOQUED';
        }
    }
    statusCardIcon(status) {
        if (status === '2') {
            return 'lock-closed';
        }
        else {
            return 'ellipse';
        }
    }
    statusColor(status) {
        switch (status) {
            case '0': return 'active-color';
            case '1': return 'inactive-color';
            case '2': return 'bloqued-color';
        }
    }
    positionCard(index) {
        switch (index) {
            case 0: return '';
            case 1: return 'position1';
            case 2: return 'position2';
            case 3: return 'position3';
            case 4: return 'position4';
            case 5: return 'position5';
            case 6: return 'position6';
            case 7: return 'position7';
            case 8: return 'position8';
            case 9: return 'position9';
            case 10: return 'position10';
            case 11: return 'position11';
            case 12: return 'position12';
        }
    }
    formatNumberCard(numberCard) {
        return numberCard.substr(2, 4);
    }
};
__decorate([
    Input()
], UiCCardsManagerComponent.prototype, "cards", void 0);
__decorate([
    Input()
], UiCCardsManagerComponent.prototype, "noCards", void 0);
__decorate([
    Input()
], UiCCardsManagerComponent.prototype, "cardSelected", void 0);
__decorate([
    Input()
], UiCCardsManagerComponent.prototype, "imageTag", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "rqCard", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "ulkCard", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "cgPassword", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "blCard", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "csCard", void 0);
__decorate([
    Output()
], UiCCardsManagerComponent.prototype, "actCard", void 0);
UiCCardsManagerComponent = __decorate([
    Component({
        selector: 'ui-c-cards-manager',
        template: "<div class=\"ui-c-cards-manager p-0\">\n  <div class=\"col-12 px-0 pb-3 row m-0\">\n\n    <div class=\"request-card-selected\" *ngIf=\"noCards\" (click)=\"requestCard()\">\n      <div class=\"ion-padding d-flex justify-content-center\">\n        <ion-text class=\"ion-text ion-text-center font-family-bold d-flex\">\n          <ion-icon class=\"font-size-20\" name=\"add-outline\"></ion-icon>\n          <p class=\"ion-text ion-no-margin font-size-14\">\n            {{'CARDS.CARD_MANAGER.REQUEST_CARD' | wlpTranslate}}\n          </p>\n        </ion-text>\n      </div>\n    </div>\n\n    <div class=\"card-selected\" *ngIf=\"!noCards\" (click)=\"showButtons(cardSelected)\">\n      <div [ngClass]=\"'m-0 p-0 justify-content-center ' + blockedCard(cardSelected.status)\"\n        *ngIf=\"cardSelected.status === '2'\" (click)=\"unlockedCard(cardSelected)\">\n        <div class=\"justify-content-center\">\n          <ion-icon class=\"font-size-40\" name=\"lock-closed\"></ion-icon>\n        </div>\n        <ion-text class=\"ion-text ion-text-center font-family-semibold\">\n          <p class=\"ion-text ion-no-margin font-size-12\">\n            {{statusCard(cardSelected.status) | wlpTranslate}}</p>\n          <p class=\"ion-text ion-no-margin font-size-12\">{{'CARDS.CARD_MANAGER.UNLOCK' | wlpTranslate}}\n          </p>\n        </ion-text>\n      </div>\n\n      <div class=\"pt-3 px-3 d-flex justify-content-lg-between\">\n        <ion-text class=\"ion-text ion-text-left font-family-bold d-flex\">\n          <ion-icon [ngClass]=\"'font-size-16 ' + statusColor(cardSelected.status)\"\n            [name]=\"statusCardIcon(cardSelected.status)\"></ion-icon>\n          <p [ngClass]=\"'ion-text ion-no-margin font-size-12 ' + statusColor(cardSelected.status)\">\n            {{statusCard(cardSelected.status) | wlpTranslate}}\n          </p>\n          <p class=\"ion-text pl-4 ion-no-margin font-size-14\">\n            \u2022\u2022\u2022\u2022{{formatNumberCard(cardSelected.currentAccount.cardCheck)}}</p>\n        </ion-text>\n        <div class=\"flagCard\">\n          <svg-icon [stretch]=\"false\" [src]=\"imageTag\"></svg-icon>\n        </div>\n      </div>\n      <div class=\"name-card px-3\">\n        <ion-text class=\"ion-text ion-text-left font-family-bold d-flex\">\n          <p class=\"ion-text ion-no-margin font-size-12\">{{cardSelected.nameCard}}</p>\n        </ion-text>\n      </div>\n    </div>\n\n    <div class=\"buttons\" *ngIf=\"swButtons\">\n      <ion-button expand=\"block\" class=\"card-button\" (click)=\"changePassword(cardSelected)\">\n        {{'CARDS.CARD_MANAGER.BUTTONS.CHANGE_PASSWORD' | wlpTranslate}}\n      </ion-button>\n      <ion-button expand=\"block\" class=\"card-button\" (click)=\"blockCard(cardSelected)\">\n        {{'CARDS.CARD_MANAGER.BUTTONS.BLOCK' | wlpTranslate}}\n      </ion-button>\n      <ion-button expand=\"block\" class=\"card-button\" (click)=\"closeCard(cardSelected)\">\n        {{'CARDS.CARD_MANAGER.BUTTONS.CLOSE' | wlpTranslate}}\n      </ion-button>\n    </div>\n  </div>\n\n  <div class=\"col-12 p-0\">\n    <div *ngFor=\"let card of cards; let i = index\" [ngClass]=\"'m-0 p-0 ' + positionCard(i)\">\n\n      <div class=\"cards\" (click)=\"selectCard(card)\">\n        <div class=\"pt-3 px-3 d-flex justify-content-lg-between\">\n          <ion-text class=\"ion-text ion-text-left font-family-bold d-flex\">\n            <ion-icon [ngClass]=\"'font-size-16 ' + statusColor(card.status)\" [name]=\"statusCardIcon(card.status)\">\n            </ion-icon>\n            <p [ngClass]=\"'ion-text ion-no-margin font-size-12 ' + statusColor(card.status)\">\n              {{statusCard(card.status) | wlpTranslate}}\n            </p>\n            <p class=\"ion-text pl-4 ion-no-margin font-size-14\">\u2022\u2022\u2022\u2022{{formatNumberCard(card.numberCard)}}\n            </p>\n          </ion-text>\n          <div class=\"flagCard\">\n            <svg-icon [stretch]=\"false\" [src]=\"imageTag\"></svg-icon>\n          </div>\n        </div>\n        <div class=\"name-card px-3\">\n          <ion-text class=\"ion-text ion-text-left font-family-bold d-flex\">\n            <p class=\"ion-text ion-no-margin font-size-12\">{{card.nameCard}}</p>\n          </ion-text>\n        </div>\n      </div>\n\n    </div>\n    <div class=\"request-card\" *ngIf=\"!noCards\" (click)=\"requestCard()\">\n      <div class=\"ion-padding d-flex justify-content-center\">\n        <ion-text class=\"ion-text ion-text-center font-family-bold d-flex\">\n          <ion-icon class=\"font-size-20\" name=\"add-outline\"></ion-icon>\n          <p class=\"ion-text ion-no-margin font-size-14\">\n            {{'CARDS.CARD_MANAGER.REQUEST_CARD' | wlpTranslate}}\n          </p>\n        </ion-text>\n      </div>\n    </div>\n  </div>\n\n</div>\n",
        styles: [""]
    })
], UiCCardsManagerComponent);

let UiCCardsManagerModule = class UiCCardsManagerModule {
};
UiCCardsManagerModule = __decorate([
    NgModule({
        declarations: [UiCCardsManagerComponent],
        imports: [
            CommonModule,
            IonicModule,
            UiBsTranslateModule,
            AngularSvgIconModule.forRoot()
        ],
        exports: [
            UiCCardsManagerComponent
        ],
    })
], UiCCardsManagerModule);

/*
 * Public API Surface of ui-c-cards-manager
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCCardsManagerComponent, UiCCardsManagerModule };
//# sourceMappingURL=wlp-ui-c-cards-manager.js.map
